import { RepositoryFactory } from "../Repository/RepositoryFactory";
const RackRepository = RepositoryFactory.get("rack_repository");

export const saveRack = async (arg) => {
  let { data } = await RackRepository.RackModel({
    request: {
      method: "saveRack",
      data: {
        company_code: localStorage.getItem("companyCode"),
        racks: arg,
      },
    },
  });

  return data;
};

export const updateRack = async (arg) => {
  let { data } = await RackRepository.RackModel({
    request: {
      method: "updateRack",
      data: arg,
    },
  });

  return data;
};

export const getAllRacks = async () => {
  let { data } = await RackRepository.RackModel({
    request: {
      method: "getRacksByCompany",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  });

  return data;
};

export const deleteRack = async (arg) => {
  let { data } = await RackRepository.RackModel({
    request: {
      method: "deleteRack",
      data: {
        company_code: localStorage.getItem("companyCode"),
        racks: arg,
      },
    },
  });

  return data;
};
